import { useEffect, useRef } from "react";

const NotificationMicrofrontend = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const currentContainer = containerRef.current;
    const SystemJS = (window as any).System;
    let moduleInstance: any = null;
    SystemJS.import("@simplex/simplex-platform-notification-webui")
      .then((module: any) => {
        if (currentContainer && module?.mount) {
          moduleInstance = module;
          module.mount({ domElement: currentContainer });
        }
      })
      .catch((err: any) => console.error("Error cargando micro frontend Angular:", err));
    return () => {
      if (moduleInstance?.unmount && currentContainer) {
        moduleInstance.unmount({ domElement: currentContainer });
      }
    };
  }, []);
  return <div className="notification-icon" ref={containerRef}></div>;
};

export default NotificationMicrofrontend;